import { render, staticRenderFns } from "./ElementAdSingle.vue?vue&type=template&id=9bc3162c&scoped=true&"
import script from "./ElementAdSingle.vue?vue&type=script&lang=js&"
export * from "./ElementAdSingle.vue?vue&type=script&lang=js&"
import style0 from "./ElementAdSingle.vue?vue&type=style&index=0&id=9bc3162c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc3162c",
  null
  
)

export default component.exports